import {
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper, Button, Dialog, DialogActions, DialogContent, Box, Stack, Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useDataProvider } from 'react-admin';


// Composant pour afficher des champs spécifiques
const FieldDisplay = ({ label, value }) => {
    return (
        <Box mb={2}>
            {typeof value === 'object' && value !== null ? (
                <Box ml={2}>
                    {Object.entries(value).map(([childKey, childValue]) => (
                        <Stack direction="row">
                            <Typography variant="body2">{childKey} : &nbsp;</Typography>
                            <FieldDisplay key={childKey} label={childKey} value={childValue} />
                        </Stack>
                    ))}
                </Box>
            ) : (
                <Typography variant="body2">{value !== null ? value.toString() : 'N/A'}</Typography>
            )}
        </Box>
    );
};

const InformationTable = ({ data, title }) => {
    return (
        <TableContainer component={Paper}>
            <Typography variant="h5" component="div" style={{ padding: 16 }}>
                {title}
            </Typography>
            <Table aria-label="information table">
                <TableHead>
                    <TableRow>
                        <TableCell>Key</TableCell>
                        <TableCell>Value</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {Object.entries(data).map(([key, value]) => (
                        <TableRow key={key}>
                            <TableCell component="th" scope="row">
                                {key}
                            </TableCell>
                            <TableCell>
                                <FieldDisplay label={key} value={value} />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default function SendingDetailsDialog({ mailing, open, handleClose }) {

    const dataProvider = useDataProvider();

    const [mailingDetails, setMailingDetails] = useState(null);

    const [recipients, setRecipients] = useState(null);

    useEffect(() => {
        dataProvider.getCustom('Admin/Mailing/Details', { id: mailing?.id })
            .then((data) => {
                setMailingDetails(data.data)
            })
            .catch((e) => {
                console.log(e)

            });

        dataProvider.getCustom('Admin/Mailing/Recipients', { id: mailing?.id })
            .then((data) => {
                setRecipients(data?.data?.recipients)
            })
            .catch((e) => {
                console.log(e)

            });
    }, [dataProvider, mailing?.id])

    return (
        <Dialog
            fullWidth
            maxWidth="lg"
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby={"alert-dialog-description-" + mailing?.id}
        >
            <DialogContent>
                <Stack spacing={2}>
                    {
                        mailingDetails != null &&
                        <InformationTable data={mailingDetails} title="Détails de l'envoi" />
                    }
                    {
                        recipients != null &&
                        <InformationTable data={recipients} title="Destinataires" />
                    }
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Fermer
                </Button>
            </DialogActions>
        </Dialog>
    )
}